var render = function render(){var _vm=this,_c=_vm._self._c;return _c('consoHistory',{attrs:{"title":_vm.$t('title.merchandising'),"type-filter":_vm.typeFilter}})
}
var staticRenderFns = []

export { render, staticRenderFns }